function getAnaliseSteps(status) {
    let stepItens = [
        {
            posicao: 1,
            label: 'IARA',
            codigo: 'IARA',
            isEditing: false,
            completed: status.etapaIARA,
            jump: status.jumpEtapaIARA
        },
        {
            posicao: 2,
            label: 'MRA',
            codigo: 'MRA',
            isEditing: false,
            completed: status.etapaMRA,
            jump: status.jumpEtapaMRA
        },
        {
            posicao: 3,
            label: 'PRADA',
            codigo: 'PRADA',
            isEditing: false,
            completed: status.etapaPRADA,
            jump: status.jumpEtapaPRADA
        },
        {
            posicao: 4,
            label: 'RESUMO',
            codigo: 'RESUMO',
            isEditing: false,
            completed: status.etapaResumo  ,
            jump: status.jumpEtapaResumo
        },
    ];
    return stepItens;
};

const stepItens = [
    {
        posicao: 1,
        label: 'IARA',
        codigo: 'IARA',
        isEditing: false,
        completed: false,
        jump: false
    },
    {
        posicao: 2,
        label: 'MRA',
        codigo: 'MRA',
        isEditing: false,
        completed: false,
        jump: false
    },
    {
        posicao: 3,
        label: 'PRADA',
        codigo: 'PRADA',
        isEditing: false,
        completed: false,
        jump: false
    },
    {
        posicao: 4,
        label: 'RESUMO',
        codigo: 'RESUMO',
        isEditing: false,
        completed: false,
        jump: false
    },
];
export {
    stepItens,
    getAnaliseSteps
};
